import { render } from "./BaseCuuriosPlanning.vue?vue&type=template&id=d357b188"
import script from "./BaseCuuriosPlanning.vue?vue&type=script&lang=js"
export * from "./BaseCuuriosPlanning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__